<template>
  <label class="otb-interactive-tag" :class="inputClasses">
    <input
      class="otb-interactive-tag__input"
      type="radio"
      :checked="checked"
      :disabled="disabled"
      :name="name"
      :value="value"
      @click="inputClick"
      v-if="variant === 'radio'"
    />
    <span class="otb-interactive-tag__text wb-type-copy-secondary">
      <slot />
    </span>
    <button
      v-if="variant === 'delete'"
      class="otb-interactive-tag__delete-btn"
      @click="deleteClick"
    >
      <wb-icon name="bds/close/24"></wb-icon>
    </button>
  </label>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import { InteractiveTagClasses } from '../../models/entities/interactive-tag.model';

export default defineComponent({
  name: 'otb-interactive-tag',
  props: {
    checked: Boolean,
    disabled: Boolean,
    name: String,
    value: String,
    variant: String,
  },
  setup(props, { emit }) {
    const inputClasses = computed((): InteractiveTagClasses => {
      return {
        'otb-interactive-tag--checked': props.checked,
        'otb-interactive-tag--disabled': props.disabled,
        'otb-interactive-tag--radio': props.variant === 'radio',
        'otb-interactive-tag--delete': props.variant === 'delete',
      };
    });

    const inputClick = (): void => {
      emit('change', {
        name: props.name,
        value: props.value,
        checked: props.checked,
      });
    };

    const deleteClick = (): void => {
      emit('delete', {
        name: props.name,
        value: props.value,
      });
    };

    return {
      deleteClick,
      inputClasses,
      inputClick,
    };
  },
});
</script>
<style lang="scss" src="./interactive-tag.scss"></style>
